import { Html5Qrcode, QrcodeSuccessCallback } from "html5-qrcode";
import { useRef } from "react";
import { waitVisible } from "./scanner";

interface Html5QrcodeHack extends Html5Qrcode {
  _elementId: string;
}

async function hardStop(qr: Html5Qrcode | null) {
  if (!qr) return;

  try {
    await qr.stop();
  } finally {
    await qr.clear();
    const video = document.querySelector<HTMLVideoElement>(
      `#${(qr as Html5QrcodeHack)._elementId} video`
    );
    if (video && video.srcObject instanceof MediaStream) {
      video.srcObject.getTracks().forEach(t => t.stop());
    }
  }
}

export function useHtml5Qr(id: string, onOk: QrcodeSuccessCallback) {
  const qrRef = useRef<Html5Qrcode | null>(null);

  const start = async () => {
    if (qrRef.current) return;

    await waitVisible(id);

    let attempt = 0;
    while (attempt < 3) {
      try {
        qrRef.current = new Html5Qrcode(id);
        await qrRef.current.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 250, height: 100 } },
          onOk,
          (e) => console.error("scan error", e)
        );
        document
          .querySelector(`#${id} video`)
          ?.setAttribute("playsinline", "true");
        return;
      } catch (e: any) {
        if (e.name !== "NotReadableError") throw e;
        await new Promise((r) => setTimeout(r, 300));
        attempt++;
      }
    }
    throw new Error("CAMERA_START_FAILED");
  };

  const stop = async () => {
    await hardStop(qrRef.current);
    qrRef.current = null;
  };

  return { start, stop };
}
